
import roomService from '@/service/room';
import giftService from '@/service/gift';
import { DATA_ERROR } from '@/constants';

export default {
  state: () => ({
    roomInfo: null,
    giftConfig: null,
    giftPanel: null,
    balance: null,
    setBalanceTime: Date.now(),
  }),
  mutations: {
    setRoomInfo(state, data) {
      state.roomInfo = data;
    },

    setGiftConfig(state, data) {
      state.giftConfig = data;
    },

    setGiftPanel(state, data) {
      state.giftPanel = data;
    },

    setBalance(state, data) {
      state.balance = data;
      state.setBalanceTime = Date.now();
    },
    blockLive(state, data) {
      state.roomInfo.state = 0;
      if (!state.roomInfo.block_info) {
        state.roomInfo.block_info = data;
      } else {
        const { notice, end_time } = data;
        state.roomInfo.block_info.notice = notice;
        state.roomInfo.block_info.end_time = end_time;
      }
    },
  },
  actions: {
    async getRoomInfo(store, payload) {
      try {
        const { roomId } = payload;
        const { data } = await roomService.getRoomInfo(roomId);
        store.commit('setRoomInfo', data);
        return data;
      } catch (e) {
        console.log('**error(actions.getRoomInfo):', e);
        if (!import.meta.env.SSR) {
          store.commit('setRoomInfo', DATA_ERROR);
        }
        return {};
      }
    },
    async getBalance({ commit }) {
      try {
        const { data: { stars } } = await giftService.getBalance();
        commit('setBalance', stars);
      } catch (e) {
        console.log('**error(actions.getBalance):', e);
      }
    },
    async getGiftPanel({ commit }) {
      try {
        const { data: { list } } = await giftService.getPanel();
        commit('setGiftPanel', list);
      } catch (e) {
        console.log('**error(actions.getGiftPanel):', e);
      }
    },
    async blockLive({ commit }, payload) {
      commit('blockLive', payload);
    },
  },
  getter: {

  }
};